
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 23.143C5.856 23.143.857 18.144.857 12 .857 5.856 5.856.857 12 .857 18.144.857 23.143 5.856 23.143 12c0 6.144-4.999 11.143-11.143 11.143z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M17.143 6.857H6.857a.428.428 0 100 .857h10.286a.428.428 0 100-.857zM17.143 11.571H6.857a.428.428 0 100 .857h10.286a.428.428 0 100-.857zM17.143 16.286H6.857a.428.428 0 100 .857h10.286a.428.428 0 100-.857z","fill":"#00003C"}})])
          )
        }
      }
    